import {
  StyledChevron,
  StyledStats,
  StyledTyreItemSummary,
  StyledTyreTypeIdentifier,
} from './TyreInformation.styles';
import Box from '@/modules/components/Box/Box';
import { ChevronRight } from '@volkswagen-onehub/icons-core';
import {
  Text,
  Image,
  TextTag,
  TokenTextAppearance,
  TokenTextColor,
  DesignTokenSizeEnum,
} from '@volkswagen-onehub/components-core';
import { TyreData } from '@/types';
import { useTribalContext } from '@/context/tribal';

function TyreInformationSummary({
  tyre,
  onClick,
}: {
  tyre: TyreData;
  onClick: () => void;
}) {
  const { contentManager } = useTribalContext();
  const {
    tyreLabelUrl,
    tyreSpecification: {
      tradeName,
      fuelEfficiencyPerformanceClass,
      externalRollingNoise,
      wetGripPerformanceClass,
      tyreTypeIdentifier,
      sizeDesignation: { tyreSizeDesignation },
    },
  } = tyre;

  return (
    <StyledTyreItemSummary onClick={onClick}>
      <div>
        <Image src={tyreLabelUrl} alt="energy label image" />
      </div>
      <div>
        <Box mb={DesignTokenSizeEnum.static150}>
          <Box mb={DesignTokenSizeEnum.static250}>
            <Text
              tag={TextTag.h3}
              appearance={TokenTextAppearance.headline300}
              bold
            >
              {tradeName.toUpperCase()}
            </Text>
          </Box>

          <StyledStats>
            <Box mb={DesignTokenSizeEnum.static150}>
              <Text
                tag={TextTag.p}
                appearance={TokenTextAppearance.copy100}
                color={TokenTextColor.inherit}
              >
                {contentManager.get('tyre-information-size-designation-label')}
                <br />
                <strong>{tyreSizeDesignation}</strong>
              </Text>
            </Box>

            <Text
              tag={TextTag.p}
              appearance={TokenTextAppearance.copy100}
              color={TokenTextColor.inherit}
            >
              {contentManager.get(
                'tyre-information-fuel-efficiency-class-label'
              )}
              <br />
              <strong>{fuelEfficiencyPerformanceClass}</strong>
            </Text>
          </StyledStats>
        </Box>
      </div>
      <div>
        <Box mb={DesignTokenSizeEnum.static150}>
          <Box mb={DesignTokenSizeEnum.static250}>
            <StyledTyreTypeIdentifier>
              <Text
                tag={TextTag.h3}
                appearance={TokenTextAppearance.headline300}
                color={TokenTextColor.inherit}
                bold
              >
                {tyreTypeIdentifier}
              </Text>
            </StyledTyreTypeIdentifier>
          </Box>

          <StyledStats>
            <Box mb={DesignTokenSizeEnum.static150}>
              <Text
                tag={TextTag.p}
                appearance={TokenTextAppearance.copy100}
                color={TokenTextColor.inherit}
              >
                {contentManager.get('tyre-information-rolling-noise-label')}
                <br />
                <strong>{`${externalRollingNoise.value} ${externalRollingNoise.unit}`}</strong>
              </Text>
            </Box>

            <Text
              tag={TextTag.p}
              appearance={TokenTextAppearance.copy100}
              color={TokenTextColor.inherit}
            >
              {contentManager.get('tyre-information-wet-grip-class-label')}
              <br />
              <strong>{wetGripPerformanceClass}</strong>
            </Text>
          </StyledStats>
        </Box>
      </div>
      <StyledChevron>
        <ChevronRight />
      </StyledChevron>
    </StyledTyreItemSummary>
  );
}

export default TyreInformationSummary;
